import { createSelector } from '@reduxjs/toolkit';
import { PayoutState } from '../types/payout.types';

interface RootState {
    payout: PayoutState;
}

export const selectPayoutState = (state: RootState) => state.payout;

export const selectPayoutLoading: (state: RootState) => boolean = createSelector(
    selectPayoutState,
    (payoutState): boolean => payoutState.loading
);

export const selectPayoutError: (state: RootState) => string | null = createSelector(
    selectPayoutState,
    (payoutState): string | null => payoutState.error
);

export const selectPayoutForm: (state: RootState) => PayoutState['form'] = createSelector(
    selectPayoutState,
    (payoutState): PayoutState['form'] => payoutState.form
);

export const selectPayoutUpdating: (state: RootState) => boolean = createSelector(
    selectPayoutState,
    (payoutState): boolean => payoutState.updating
);
